
















































































































import Vue, { PropType } from 'vue'
import { isEqual } from 'lodash'
import XButton from '@/components/atoms/Button/XButton.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import {
  Input as RecipientInput,
  toInput as toRecipientInput,
} from '../_Partial/Recipient.vue'
import { AgentSalesDestination, Mutation } from '@/types/generated/graphql'
import XDialog from '@/components/atoms/Dialog/XDialog.vue'
import { pref } from '@/packages/Prefectures'
import UPDATE_MUTATION from '@/graphql/partner/updateAgentSalesDestination.gql'

type Data = {
  name: string
}

type Props = {
  recipient: RecipientInput
  partnerId: string
  storeId: string
  selectedDestination: AgentSalesDestination | null
}

type Methods = {
  open: () => void
  close: () => void
  update: () => void
  hasUpdate: () => boolean
}

type Computed = {
  prefName?: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'AgentDestinationSave',
  components: {
    XDialog,
    XButton,
    XFormLabel,
  },
  data: function () {
    return {
      name: 'AgentDestinationSave',
    }
  },
  props: {
    recipient: {
      type: Object as PropType<RecipientInput>,
      required: true,
    },
    // FIXME partnerIdはいずれ消す
    partnerId: {
      type: String,
      required: true,
    },
    storeId: {
      type: String,
      required: true,
    },
    selectedDestination: {
      type: Object,
      required: false,
    },
  },
  computed: {
    prefName() {
      return pref(Number(this.recipient.prefId))?.name
    },
  },
  methods: {
    open() {
      this.$modal.show(this.name)
    },
    close() {
      this.$modal.hide(this.name)
      this.$emit('close')
    },
    async update() {
      await this.$apollo.mutate<Mutation>({
        mutation: UPDATE_MUTATION,
        variables: {
          input: {
            ...this.recipient,
            partnerId: this.partnerId,
            storeId: this.storeId,
            agentSalesDestinationId: this.selectedDestination
              ?.agentSalesDestinationId,
          },
        },
      })
      this.close()
    },
    hasUpdate() {
      if (!this.selectedDestination) {
        return true
      }
      const recipient = toRecipientInput(this.selectedDestination)
      return !isEqual(recipient, this.recipient)
    },
  },
})
